import React from "react";

const ReminderHexIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ color: "var(--color-cheddar)", flexShrink: 0 }}
    aria-hidden="true"
  >
    <path d="M12 2.8 19.8 7.4v9.2L12 21.2 4.2 16.6V7.4Z" />
    <path d="M12 8.2v4.4" />
    <path d="M12 16.1h.01" strokeWidth="2.2" />
  </svg>
);

export default ReminderHexIcon;
